import { componentMap , defaultRoute } from '@/router/router'
import { tree , map } from './base'
import config from '@/config'

let menuReady = false

let menuRaw = []

let menuTree = {}

let menuIdMap = {}

let menuMap = {}

let session = {}

let userinfo = {}

let permissionMap = {}

const storage = localStorage

const getIcon = (d) => {
  try{
    let data = JSON.parse(d.remark)
    if(data.icon) return data.icon
  }catch(e){
    return ''
  }
}
const service = {
  /*
   * 获取登录状态
   * 0 未登录 无 token
   * 1 已登录 有 token
   * 2 未登录 有 token
   */
  getStatus(){
    if(!session.accessToken){
      return 0
    }
    else if( session.accessToken && menuReady ){
      return 1
    }else if(session.accessToken && !menuReady){
      return 2
    }
  },

  /*
   * 获取菜单
   */
  getMenu(){
    return menuTree
  },

  /*
   * 设置菜单
   */
  setMenu(v) {
    let menus = (v || [])
    //通用 浮动
    .filter(i => i.menuType == 0 || i.menuType == 3)
    .sort((a,b) => a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0)
    .map(i=>({id:i.id , path : i.url, title:i.name , code:i.code , parentId:i.parentId , icon: componentMap[i.code] ? componentMap[i.code].icon : getIcon(i) , visible:i.orderIndex >=0}))

    permissionMap = {} 
    menuIdMap = {}
    for( let i of (v || [])){
      permissionMap[i.code] = 1
      menuIdMap[i.id] = 1
    }
    menuRaw = v
    menuTree = tree( menus )
    // menuIdMap = map( menus , 'id' )
    menuReady = true
    return menuTree
  },

  ready() {
    return menuReady
  },
  
  clear(){
    session = {}
    storage.removeItem('SESSION')

    menuRaw = null
    menuTree = []
    menuIdMap = {}
    menuReady = false
    permissionMap = {}

  },
  
  getLocalMenu(){
    let flatten = (d , p = '' , id = 1) => {
      return d.reduce((t,i,idx) => {
        return t.concat( {
          id:id * 100 + idx,
          name: i.meta ? i.meta.title : i.name,
          code:i.name,
          url: (p + '/'+ i.path).replace(/\/\//g, '/'),
          menuType:3,
          parentId:id,
          orderIndex:1
        }, i.children ? flatten(i.children, (p + '/' + i.path).replace(/\/\//g, '/'), id * 100 + idx) : [])
      },[])
    }

    return flatten(defaultRoute)
  },

  getToken: function() {
    return session.accessToken
  },
  getUserName: function() {
    return session.userName
  },

  setSession(data){
    session = {...data}
    storage.setItem('SESSION',JSON.stringify(session))
  },

  getSession(){
    return session
  },

  setUserInfo(data){
    userinfo = data
  },

  getUserInfo(){
    return userinfo
  },

  hasAuthority(code, flag = false){
    if( config.dev ) return true
    if(flag){
      return menuIdMap[code] == 1
    }else{
      return permissionMap[code] == 1
    }
  },

  access(code , flag = false){
    if( config.dev ) return true
    if(flag){
      return menuIdMap[code] == 1
    }else{
      return permissionMap[code] == 1
    }
  },

  removeSession: function() {
    session = {}
    storage.removeItem('SESSION')
    menuReady = false
    menuRaw = []
    menuTree = []
    menuIdMap = {}
    permissionMap = {}
  }
}

try{
  let s = JSON.parse( storage.getItem('SESSION') )
  if( s ) session = s
}catch(e){

}

export default service